import {Component, Inject, OnInit, Renderer2, ViewChild, signal} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule, Location } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MasterdataService } from 'src/app/home/services/masterdata.service';


@Component({
  selector: 'app-add-master-product',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './add-master-product.component.html',
  styleUrls: ['./add-master-product.component.scss', '../../../../app.component.scss', '../../../../shared/base-modal.style.scss']

})
export class AddMasterProductComponent {

  public propData: any;
  public regions: any;
  // public countries: any;
  public country: any;
  public cities: any;
  public selectedRegion: any = {id: "", value: ""};
  public selectedCountry: any = {id: "", value: ""};
  public selectedCities: any = {id: "", value: ""};
  public isEdited: boolean = false;
  public nameTxt: string;
  public latitudeTxt: string;
  public longitudeTxt: string;
  public consumptionEmailRecipientsTxt: string;
  public lowStockAlertEmailRecipientsTxt: string;
  public consumptionEmails: string[] = [];
  public consumptionEmailInput: string = '';
  public invalidEmailError: string = '';
  public lowStockAlertEmails: string[] = [];
  public lowStockAlertEmailInput: string = '';
  public invalidLowStockEmailError: string = '';
  public search: any;

  constructor(
    public dialogRef: MatDialogRef<AddMasterProductComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private masterdataService: MasterdataService,
    private renderer: Renderer2
  ) {
    if(data){
      this.propData = data;
      this.regions = this.propData.regions;
      this.country = this.propData.country;
      this.cities = this.propData.cities;
    }
  }

  ngOnInit(): void {
    // if (this.propData && this.propData.type === "edit") {
    //   console.log(this.propData);
  
    //   // Handle regions data
    //   if (this.propData.regions) {
    //     console.log(this.propData.regions, "regions"); 
  
    //     let regions = this.propData.regions;
    //     let regionIdToFind = this.propData.item.region_id;
    //     let foundRegion = null; 
  
    //     // Manually iterate over the regions array to find a match
    //     for (let i = 0; i < regions.length; i++) {
    //       if (regions[i].id === regionIdToFind) {
    //         foundRegion = regions[i];
    //         break;
    //       }
    //     } 
  
    //     if (foundRegion) {
    //       this.selectedRegion = foundRegion;
    //       console.log(this.selectedRegion, "selected body ");
    //       this.onRegionTypeChange(this.selectedRegion);
    //     } else {
    //       console.log("No matching body part found for id:", regionIdToFind);
    //     }
    //   } else {
    //     console.log("No bodyparts data available");
    //   }
    //   if (this.propData.country) {
    //     console.log(this.propData.country, "country"); 
  
    //     let country = this.propData.country;
    //     let countryIdToFind = this.propData.item.country_id;
    //     let foundCountry = null; 
    //     for (let i = 0; i < country.length; i++) {
    //       if (country[i].id === countryIdToFind) {
    //         foundCountry = country[i];
    //         break;
    //       }
    //     } 
  
    //     if (foundCountry) {
    //       this.selectedCountry = foundCountry;
    //       console.log(this.selectedCountry, "selected body ");
    //       this.onCountryTypeChange(this.selectedCountry);
    //     } else {
    //       console.log("No matching body part found for id:", countryIdToFind);
    //     }
    //   } else {
    //     console.log("No bodyparts data available");
    //   }
    //   if (this.propData.cities) {
    //     console.log(this.propData.cities, "cities"); 
  
    //     let cities = this.propData.cities;
    //     let citiesIdToFind = this.propData.item.city_id;
    //     let foundCities = null; 
    //     for (let i = 0; i < cities.length; i++) {
    //       if (cities[i].id === citiesIdToFind) {
    //         foundCities = cities[i];
    //         break;
    //       }
    //     } 
  
    //     if (foundCities) {
    //       this.selectedCities = foundCities;
    //       console.log(this.selectedCities, "selected city ");
    //       this.onCitiesTypeChange(this.selectedCities);
    //     } else {
    //       console.log("No matching body part found for id:", citiesIdToFind);
    //     }
    //   } else {
    //     console.log("No bodyparts data available");
    //   }
    //   this.nameTxt = this.propData.item.name;
    //   this.latitudeTxt = this.propData.item.latitudeTxt;
    //   this.longitudeTxt = this.propData.item.longitudeTxt;
    //   this.isEdited = true;

    //   console.log(this);
    // }
    if (this.propData && this.propData.type === "edit") {
      let regions = this.propData.regions || [];
      let country = this.propData.country || [];
      let cities = this.propData.cities || [];

      let regionIdToFind = this.propData.item.region_id;
      this.selectedRegion = regions.find((r: any) => r.id === regionIdToFind) || this.selectedRegion;

      let countryIdToFind = this.propData.item.country_id;
      this.selectedCountry = country.find((c: any) => c.id === countryIdToFind) || this.selectedCountry;

      let citiesIdToFind = this.propData.item.city_id;
      this.selectedCities = cities.find((c: any) => c.id === citiesIdToFind) || this.selectedCities;
      
      this.nameTxt = this.propData.item.name;
      this.latitudeTxt = this.propData.item.latitude;   // Fix here
      this.longitudeTxt = this.propData.item.longitude; // Fix here
      this.consumptionEmailRecipientsTxt = this.propData.item.consumption_email_recipients;   // Fix here
      this.lowStockAlertEmailRecipientsTxt = this.propData.item.low_stock_alert_email_recipients;
      // Initialize email chips from comma-separated string
      if (this.consumptionEmailRecipientsTxt) {
        this.consumptionEmails = this.consumptionEmailRecipientsTxt.split(',').map(email => email.trim()).filter(email => email);
      }
      if (this.lowStockAlertEmailRecipientsTxt) {
        this.lowStockAlertEmails = this.lowStockAlertEmailRecipientsTxt.split(',').map(email => email.trim()).filter(email => email);
      }
      this.isEdited = true;
    }
    this.renderer.listen('window', 'click', (e: Event) => {
      if (!document.querySelector('.cabinet-dropdown.stores')?.contains(e.target as Node)) {
        this.isRegionDropDown.set(false);
      }
    });
  }
  
  
  
  

  onClose(): void {
    this.dialogRef.close();
  }

   isRegionDropDown = signal(false);
   isCountryDropDown = signal(false);
   isCitiesDropDown = signal(false);

  // responseData: any = {};
  // public fileType = "";
  // public isFile = false;
  // public uploadedFile: any;
  // public statusType: string = "";
  // public statusMessage: string = "";

  // changedStoreType: any = {type: "", value: ""};
  // public isDragOver = signal(false);


  // dropFile(e) {
  //   e.preventDefault();
  //   const file = e.dataTransfer.files[0];
  //   if (file) {
  //     this.fileValidation(file)
  //   }

  //   this.isDragOver.set(false);
  // }

  // dragOverFile(e) {
  //   e.preventDefault();
  //   this.isDragOver.set(true);
  // }

  // dragLeaveFile(e) {
  //   e.preventDefault();
  //   this.isDragOver.set(false);
  // }

  // browseFile(e){
  //   e.preventDefault();
  //   let fileInput = document.getElementById("file-input");
  //   fileInput.click();
  // }

  // dragEndFile(e) {
  //   e.preventDefault();
  //   this.isDragOver.set(false);
  // }

  // onFileChange(event){
  //   event.preventDefault();
  //   const file = event.target.files[0];
  //   if (file) {
  //     this.fileValidation(file);
  //   }
  // }

  // fileValidation(file){
  //   const validFileTypes = ['csv', 'xlsx', 'xls'];
  //   let ext = file.name.substring(file.name.lastIndexOf('.') + 1);
  //   if (validFileTypes.includes(ext)) {
  //     this.isFile = true;
  //     this.uploadedFile = file;
  //   }else{
  //     this.statusType = 'error';
  //     this.statusMessage = `File format is invalid. Only Excel and CSV formats are allowed.`;
  //     this.showWarningToast();
  //   }
  // }

  // resetFile(){
  //   this.isFile = false;
  // }

  // showWarningToast(){
  //   const toastContainer = document.getElementById('warning-toast');

  //   setTimeout(function() {
  //     toastContainer.classList.add('show');
  //   }, 100);

  //   setTimeout(function() {
  //     toastContainer.classList.remove('show');
  //   }, 5000);
  // }

  onRegionTypeChange(value:any){
      this.selectedRegion = value;
      this.isRegionDropDown.set(false); 
  } 

  onCountryTypeChange(value:any){
      this.selectedCountry = value;
      this.isCountryDropDown.set(false);
  }

  onCitiesTypeChange(value:any){
     this.selectedCities = value;
     this.isCitiesDropDown.set(false)
  }

  // Email chip management methods
  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  }

  addConsumptionEmail(email?: string): void {
    const emailToAdd = email || this.consumptionEmailInput.trim();
    if (!emailToAdd) {
      this.invalidEmailError = '';
      return;
    }

    // Handle comma-separated emails
    const emails = emailToAdd.split(',').map(e => e.trim()).filter(e => e);
    let hasInvalidEmail = false;
    
    emails.forEach(email => {
      if (this.isValidEmail(email)) {
        if (!this.consumptionEmails.includes(email)) {
          this.consumptionEmails.push(email);
        }
      } else {
        hasInvalidEmail = true;
      }
    });

    if (hasInvalidEmail && emails.length > 0) {
      this.invalidEmailError = 'Please enter a valid email address';
      setTimeout(() => {
        this.invalidEmailError = '';
      }, 3000);
    } else {
      this.invalidEmailError = '';
    }

    this.consumptionEmailInput = '';
  }

  removeConsumptionEmail(email: string): void {
    const index = this.consumptionEmails.indexOf(email);
    if (index > -1) {
      this.consumptionEmails.splice(index, 1);
    }
  }

  onConsumptionEmailKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ',') {
      event.preventDefault();
      this.addConsumptionEmail();
    } else if (event.key === 'Backspace' && !this.consumptionEmailInput && this.consumptionEmails.length > 0) {
      // Remove last email chip on backspace when input is empty
      this.removeConsumptionEmail(this.consumptionEmails[this.consumptionEmails.length - 1]);
    }
  }

  onConsumptionEmailBlur(): void {
    if (this.consumptionEmailInput.trim()) {
      this.addConsumptionEmail();
    }
  }

  // Low Stock Alert Email chip management methods
  addLowStockAlertEmail(email?: string): void {
    const emailToAdd = email || this.lowStockAlertEmailInput.trim();
    if (!emailToAdd) {
      this.invalidLowStockEmailError = '';
      return;
    }

    // Handle comma-separated emails
    const emails = emailToAdd.split(',').map(e => e.trim()).filter(e => e);
    let hasInvalidEmail = false;
    
    emails.forEach(email => {
      if (this.isValidEmail(email)) {
        if (!this.lowStockAlertEmails.includes(email)) {
          this.lowStockAlertEmails.push(email);
        }
      } else {
        hasInvalidEmail = true;
      }
    });

    if (hasInvalidEmail && emails.length > 0) {
      this.invalidLowStockEmailError = 'Please enter a valid email address';
      setTimeout(() => {
        this.invalidLowStockEmailError = '';
      }, 3000);
    } else {
      this.invalidLowStockEmailError = '';
    }

    this.lowStockAlertEmailInput = '';
  }

  removeLowStockAlertEmail(email: string): void {
    const index = this.lowStockAlertEmails.indexOf(email);
    if (index > -1) {
      this.lowStockAlertEmails.splice(index, 1);
    }
  }

  onLowStockAlertEmailKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ',') {
      event.preventDefault();
      this.addLowStockAlertEmail();
    } else if (event.key === 'Backspace' && !this.lowStockAlertEmailInput && this.lowStockAlertEmails.length > 0) {
      // Remove last email chip on backspace when input is empty
      this.removeLowStockAlertEmail(this.lowStockAlertEmails[this.lowStockAlertEmails.length - 1]);
    }
  }

  onLowStockAlertEmailBlur(): void {
    if (this.lowStockAlertEmailInput.trim()) {
      this.addLowStockAlertEmail();
    }
  }

  onAdd(){
    // Add any remaining email from input
    if (this.consumptionEmailInput.trim()) {
      this.addConsumptionEmail();
    }
    if (this.lowStockAlertEmailInput.trim()) {
      this.addLowStockAlertEmail();
    }

    // Validate that at least one email is added
    if (this.consumptionEmails.length === 0) {
      return; // Don't submit if no emails
    }
    if (this.lowStockAlertEmails.length === 0) {
      return; // Don't submit if no low stock alert emails
    }

    // Convert email arrays to comma-separated strings
    this.consumptionEmailRecipientsTxt = this.consumptionEmails.join(',');
    this.lowStockAlertEmailRecipientsTxt = this.lowStockAlertEmails.join(',');
    
    let data ={
      name: this.nameTxt,
      location_id: this.selectedCities.id,
      warehouse_id: 4,
      latitude:this.latitudeTxt,
      longitude:this.longitudeTxt,
      consumption_email_recipients:this.consumptionEmailRecipientsTxt,
      low_stock_alert_email_recipients:this.lowStockAlertEmailRecipientsTxt
    }
    if(this.isEdited){
      this.masterdataService.masterEditBody('stores', this.propData.item.id,data).subscribe((res:any)=>{
        this.onClose();
      });
    }else{
      this.masterdataService.masterAddItem('stores', data).subscribe((res:any)=>{
        this.onClose();
      }); 
    }
  } 

}
